import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { multilanguage } from "redux-multilanguage";
import { connect } from "react-redux";
import { logoutUser } from "../../../redux/actions/userAction";
import { clearProducts } from "../../../redux/actions/productsAction";
import { removeFromCart } from "../../../redux/actions/cartActions";
import useToken from "../../../hook/useToken";


const MobileNavMenu = ({ strings, userData, clearProducts, logoutUser }) => {
  const history = useHistory()
  const hLogOutUser = async e => {
    e.preventDefault();
    logoutUser();
    clearProducts();
    setToken(0);
    //window.location.reload();
    history.push(process.env.PUBLIC_URL + "/");
  }

  const resetQuerySearch = (_where) => {
    //sessionStorage.setItem("filter", JSON.stringify({}))   DA ABILITARE SE VUOLE RESETTARE TUTTI I FILTRI


    sessionStorage.setItem("filter", JSON.stringify({}))
    //setSortValues({})
    //setRefresh(!refresh)
    //history.push("/")
    //setTimeout(() => history.push(process.env.PUBLIC_URL + "/shop-grid-full-width"), 10);
    //sessionStorage.setItem("currentPage", 1)

    sessionStorage.setItem("currentPage", 1)
    setTimeout(() => history.push("/"), 50);
    setTimeout(() => history.push(process.env.PUBLIC_URL + _where), 100);

    //}
  }

  const { token, setToken } = useToken();

  const handleClick = e => {
    e.currentTarget.nextSibling.classList.toggle("active");
    //console.log(userData);
  };

  return (
    <nav className="offcanvas-navigation" id="offcanvas-navigation">

      {true &&
        <div className="header-right-wrap">
          <div className="same-style account-setting  d-lg-block">
            <button
              className="account-setting-active"
              onClick={e => handleClick(e)}
            >

              <img style={{ height: 50, width: 50, borderRadius: 25 }}
                src={userData?.user?.user?.WebImage ? userData.user.user.WebImage : "https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg"}></img>


            </button>

            <div className="account-dropdown">
              <ul>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/my-account"}>Il Tuo Account</Link>
                </li>
                <li>
                  <Link onClick={e => hLogOutUser(e)}>         Disconnetti </Link>
                </li>
              </ul>
            </div>
          </div>

          {/*
                <div className="main-menu" style={{textAlign: "center"}}>
                  <Link to={process.env.PUBLIC_URL + "/my-account"}>
                      {userData.user.user.Nom}
                  </Link>
                    </div>    */}
        </div>}


      <ul>


















        {!((userData?.user?.user) && (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge))
          &&
          <li>
            <Link to={process.env.PUBLIC_URL + "/login"} >
              {"Login"}
            </Link>
          </li>
        }

        {global.aziendaID == 1 ?<li>
          <Link onClick={() => resetQuerySearch("/shop-grid-full-width?name=")} to={process.env.PUBLIC_URL + "/shop-grid-full-width"} >
            {(userData?.user?.user?.IDCli || userData?.user?.user?.IDAge) ? 'Acquisti' : 'Prodotti'}
          </Link>
        </li> : null}

        {global.aziendaID == 2 && (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge)?<li>
            <Link onClick={() => resetQuerySearch("/shop-grid-full-width?name=")} to={process.env.PUBLIC_URL + "/shop-grid-full-width"} style={{ lineHeight: '68px' }}>
              { 'Home' }
            </Link>
          </li> : null}

        {global.aziendaID == 1 ? <li>
          <Link onClick={() => resetQuerySearch("/consigliati?name=")} to={process.env.PUBLIC_URL + "/consigliati"} >
            {'Consigliati'}
          </Link>
        </li> : null}

        {global.aziendaID == 1 ? <li>
          <a className="default-btn" style={{ border: '0px' }} href='/files/catalogoDGA.pdf'>
            {"Scarica catalogo"}
          </a>
        </li> : null}



        {((userData.user.user) && (userData.user.user.IDCli || userData.user.user.IDAge) && global.aziendaID == 1) ? <li>
          {/*<img src="https://media.giphy.com/media/RKKPOi4piK6CUXiUj7/giphy.gif" style={{width:"25%", float:"left", position:"absolute", top:"17%", left:"-5%"}}></img>*/}
          <Link to={process.env.PUBLIC_URL + "/my-documents"} >I miei documenti </Link>
        </li> : null}
        {((userData.user.user) && (userData.user.user.IDCli || userData.user.user.IDAge) && global.aziendaID == 1) ? <li>
          <Link to={process.env.PUBLIC_URL + "/my-pricelist"} >Listino</Link>
        </li> : null}

        {(/*userData.user.user?.IDCli === 41917 && */
          userData?.user?.user?.IDCli &&
          window['configPegaso'].untentiModificaBanners?.includes(localStorage.getItem("IDDetCliRef")))
          ?
          <li>
            <Link to={process.env.PUBLIC_URL + "/personalizzaBanners"} >
              {'Banners'}
            </Link>
          </li> : null
        }

        {global.aziendaID == 1 ?<li>
          <Link to={process.env.PUBLIC_URL + "/about"} >
            {"Chi siamo"}
          </Link>
        </li> : null}



        {global.aziendaID == 1 ? <li>
          <Link to={process.env.PUBLIC_URL + "/contact"} >
            {strings["contact_us"]}
          </Link>
        </li> : null}
        {global.aziendaID == 1 ? <li>
            <Link to={process.env.PUBLIC_URL + "/tutorial"}>
              {strings["tutorial"]}
            </Link>
          </li> : null}
        {
          (false && <li className="hidden">
            <Link to={process.env.PUBLIC_URL + "/blog-standard"} >
              {strings["blog"]} <i className="fa fa-angle-down" />
            </Link>
            <ul className="submenu">
              <li>
                <Link to={process.env.PUBLIC_URL + "/blog-standard"} >
                  {strings["blog_standard"]}
                </Link>
              </li>
              <li>
                <Link to={process.env.PUBLIC_URL + "/blog-no-sidebar"} >
                  {strings["blog_no_sidebar"]}
                </Link>
              </li>
              <li>
                <Link to={process.env.PUBLIC_URL + "/blog-right-sidebar"} >
                  {strings["blog_right_sidebar"]}
                </Link>
              </li>
              <li>
                <Link to={process.env.PUBLIC_URL + "/blog-details-standard"} >
                  {strings["blog_details_standard"]}
                </Link>
              </li>
            </ul>
          </li>
          )}

      </ul>
    </nav>
  );
};

MobileNavMenu.propTypes = {
  strings: PropTypes.object
};

const mapStateToProps = state => {
  return {
    currency: state.currencyData,
    cartData: state.cartData,
    wishlistData: state.wishlistData,
    compareData: state.compareData,
    userData: state.userData,
    productData: state.productData
  };
}

const mapDispatchToProps = dispatch => {
  return {
    removeFromCart: (item, addToast) => {
      dispatch(removeFromCart(item, addToast));
    },
    logoutUser: () => { dispatch(logoutUser()); },
    clearProducts: () => { dispatch(clearProducts()); }
  };
};

//export default multilanguage(MobileNavMenu);
//export default MobileNavMenu;
export default connect(mapStateToProps, mapDispatchToProps)(MobileNavMenu);